(function () {
  "use strict";

  let submitting = false;
  let checkoutToken = null;

  function getCustomer() {
    return window.PROBIOTIK_CUSTOMER || null;
  }

  function isLoggedInCustomer() {
    const customer = getCustomer();
    return Boolean(customer && customer.id && customer.email);
  }

  function requireCustomer() {
    if (!isLoggedInCustomer()) {
      window.location.href =
        "/account/login?return_url=" + encodeURIComponent(window.location.pathname);
      return null;
    }
    return getCustomer();
  }

  function createCheckoutToken() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }

    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (char) {
      const random = Math.random() * 16 | 0;
      const value = char === "x" ? random : (random & 0x3 | 0x8);
      return value.toString(16);
    });
  }

  function buildCheckoutPayload() {
    const customer = requireCustomer();
    const configurator = window.PROBIOTIK_CONFIGURATOR;
    if (!customer || !configurator || !configurator.state) return null;

    const state = configurator.state;
    if (!checkoutToken) checkoutToken = createCheckoutToken();

    return {
      source: "shopify_configurator_checkout",
      checkoutToken: checkoutToken,
      productLine: state.productLine,
      configuration: {
        potency: state.potency,
        formula: state.formula,
        capsCount: state.capsCount,
        tier: state.tier,
        strainIds: Array.isArray(state.strainIds) ? state.strainIds.slice() : [],
        chewableUpgrade: state.chewableUpgrade === true,
        postbioticKg: state.postbioticKg
      },
      meta: {
        pageUrl: window.location.href
      }
    };
  }

  function showConfiguratorModal(title, text) {
    let modal = document.getElementById("ssInquiryModal");

    if (!modal) {
      modal = document.createElement("div");
      modal.id = "ssInquiryModal";
      modal.className = "ss-login-modal";
      modal.innerHTML = `
        <div class="ss-login-modal-box" role="dialog" aria-modal="true" aria-labelledby="ssInquiryModalTitle">
          <h3 id="ssInquiryModalTitle"></h3>
          <p id="ssInquiryModalText"></p>
          <div class="ss-login-modal-actions">
            <button type="button" id="ssInquiryModalClose">Verstanden</button>
          </div>
        </div>
      `;
      document.body.appendChild(modal);

      modal.addEventListener("click", function (event) {
        if (event.target.id === "ssInquiryModal" || event.target.id === "ssInquiryModalClose") {
          modal.classList.remove("open");
        }
      });
    }

    document.getElementById("ssInquiryModalTitle").textContent = title;
    document.getElementById("ssInquiryModalText").textContent = text;
    modal.classList.add("open");
  }

  function setSubmitting(value) {
    submitting = value;
    document.querySelectorAll(
      "#addConfiguratorToCart, #goStep4, [data-action='addToCart']"
    ).forEach(function (button) {
      if (value) {
        if (!button.dataset.originalText) button.dataset.originalText = button.textContent;
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        button.textContent = "Shopify-Checkout wird vorbereitet …";
      } else {
        button.disabled = false;
        button.removeAttribute("aria-busy");
        if (button.dataset.originalText) button.textContent = button.dataset.originalText;
      }
    });
  }

  function hasPurchaseConfirmation() {
    const checkbox = document.getElementById("ssPurchaseConfirm");
    if (checkbox && checkbox.checked) return true;

    showConfiguratorModal(
      "Bestätigung erforderlich",
      "Bitte bestätige die vollständige Zahlung im Shopify-Checkout und die separate Abrechnung der Versandkosten."
    );
    if (checkbox) checkbox.focus();
    return false;
  }

  async function submitCheckout() {
    if (submitting || !hasPurchaseConfirmation()) return;

    const endpoint = window.PROBIOTIK_CHECKOUT_ENDPOINT;
    const payload = buildCheckoutPayload();
    if (!payload) {
      showConfiguratorModal(
        "Konfiguration unvollständig",
        "Bitte überprüfe deine Auswahl und versuche es erneut."
      );
      return;
    }
    if (!endpoint) {
      showConfiguratorModal(
        "Technischer Fehler",
        "Der Shopify-Checkout ist aktuell nicht konfiguriert."
      );
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      });
      const result = await response.json().catch(function () { return {}; });

      if (response.status === 401 || result.code === "LOGIN_REQUIRED") {
        window.location.href =
          "/account/login?return_url=" + encodeURIComponent(window.location.pathname);
        return;
      }
      if (!response.ok) {
        throw new Error(result.message || "Der Shopify-Checkout konnte nicht erstellt werden.");
      }
      if (!result.checkoutUrl) {
        throw new Error("Shopify hat keinen Checkout-Link zurückgegeben.");
      }

      window.location.assign(result.checkoutUrl);
    } catch (error) {
      console.error("Configurator checkout failed:", error);
      setSubmitting(false);
      showConfiguratorModal(
        "Checkout konnte nicht gestartet werden",
        error.message || "Bitte versuche es später erneut oder kontaktiere uns direkt."
      );
    }
  }

  const api = {
    getCustomer: getCustomer,
    requireCustomer: requireCustomer,
    buildCheckoutPayload: buildCheckoutPayload,
    submitCheckout: submitCheckout
  };

  window.PROBIOTIK_CHECKOUT = api;
  window.PROBIOTIK_INQUIRY = api;
  window.submitCheckout = submitCheckout;
  window.submitInquiry = submitCheckout;
})();
